import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['scrollContainer', 'leftBtn', 'rightBtn'];


  scrollContainerTargetConnected(scrollContainer) {
    this.toggleBtn();
    scrollContainer.addEventListener('scroll', (evt) => {
      this.toggleBtn();
    });
  }

  leftBtnTargetConnected(leftBtn) {
    leftBtn.addEventListener('click', evt => {
      this.moveLeft();
    })
  }

  rightBtnTargetConnected(rightBtn) {
    rightBtn.addEventListener('click', evt => {
      this.moveRight();
    })
  }

  toggleBtn() {
    const scrollContainer = this.scrollContainerTarget;
    if (scrollContainer.scrollLeft === 0) {
      this.leftBtnTarget.classList.add("hidden");
    } else {
      this.leftBtnTarget.classList.remove("hidden");
    }
    if (scrollContainer.scrollLeft + scrollContainer.clientWidth + 1 >= scrollContainer.scrollWidth) {
      this.rightBtnTarget.classList.add("hidden");
    } else {
      this.rightBtnTarget.classList.remove("hidden");
    }
  }

  moveRight() {
    this.scrollContainerTarget.scrollLeft += this.scrollContainerTarget.clientWidth / 2;
  }

  moveLeft() {
    this.scrollContainerTarget.scrollLeft -= this.scrollContainerTarget.clientWidth / 2;
  }
}
